import React from "react";
import "./ClustersDataTable.scss";
import { defineMessages, useIntl } from "react-intl";
import ClusterRow from "./ClusterRow/ClusterRow";
import { Cluster } from "../utils";
// Interfaces
interface Props {
    clustersInfo: Cluster[];
    selectedClusterId: string | undefined;
    className?: string;
    selectCluster: React.JSX.Element;
}
const ClusterDataTable = ({
    clustersInfo,
    selectedClusterId,
    className,
    selectCluster,
}: Props) => {
    const intl = useIntl();
    return (
        <table className={`clusters-data-table ${className ?? ""}`}>
            <thead>
                <tr>
                    <th>{selectCluster}</th>
                    <th>
                        {intl.formatMessage(messages.responseTimeForAnExercise)}
                    </th>
                    <th>{intl.formatMessage(messages.nbrOfObjectives)}</th>
                    <th>{intl.formatMessage(messages.averageMeanScore)}</th>
                </tr>
            </thead>
            <tbody>
                {clustersInfo.map((cluster) => {
                    const isCluster = selectedClusterId === cluster.id;
                    if (!isCluster) return undefined;
                    return cluster.membersInfo.map((member) => (
                        <ClusterRow
                            key={member.id}
                            member={member}
                            selectedClusterId={selectedClusterId}
                        />
                    ));
                })}
            </tbody>
        </table>
    );
};

export default ClusterDataTable;

const messages = defineMessages({
    nbrOfObjectives: {
        id: "dashboard-clustering-variables-NB_OBJ",
        defaultMessage: "Number of opened objectives",
    },
    averageMeanScore: {
        id: "dashboard-clustering-variables-MEAN_SCORE",
        defaultMessage: "Mean score of all completed exercises /1",
    },
    responseTimeForAnExercise: {
        id: "dashboard-clustering-variables-MEAN_DUR",
        defaultMessage: "Mean time spent on each exercise",
    },
});
